import {
    getExportAgGrid,
    getExportExcel,
    getExportSSRAgGrid,
} from '@cfra-nextgen-frontend/shared/src/components/excelExport/export';
import { ApplicationType } from '@cfra-nextgen-frontend/shared/src/utils';
import logoFile from 'assets/images/MarketScopeAdvisor.svg';

export const exportExcel = getExportExcel(logoFile, ApplicationType.WealthPortal);

export const exportAgGrid = getExportAgGrid(exportExcel);

export const exportSSRAgGrid = getExportSSRAgGrid(exportExcel);
